// store/modules/user.js
import { login as apiLogin, logout as apiLogout } from '@/api/login'
import { getToken, setToken, removeToken, setRobotId, removeRobotId } from '@/utils/auth'
import { resetRouter } from '@/router'

const state = {
  token: getToken(),
  userInfo: {
    id: 0,
    username: '',
    role: null,
    robot_id: ''
  },
  permissions: [],
  roles: []
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_USER_INFO: (state, userInfo) => {
    // 确保只更新存在的字段，避免覆盖不存在的字段为undefined
    const defaultInfo = state.userInfo
    state.userInfo = { ...defaultInfo, ...userInfo }
  },

  SET_ROLES: (state, roles) => {
    state.roles = roles
  },

  SET_PERMISSIONS: (state, permissions) => {
    state.permissions = permissions || []
  },

  RESET_USER: (state) => {
    state.token = ''
    state.userInfo = { id: 0, username: '', role: null, robot_id: '' }
    state.permissions = []
    state.roles = []
  }
}
const actions = {
  login({ commit }, loginForm) {
    return new Promise((resolve, reject) => {
      apiLogin(loginForm)
        .then(response => {
          const { data } = response
          
          if (!data || !data.token) {
            reject(new Error('登录失败：返回数据异常'))
            return
          }
          
          // 设置token
          commit('SET_TOKEN', data.token)
          setToken(data.token)
          
          // 构建userInfo对象，从返回数据中提取用户信息
          const userInfo = {
            id: data.id || 0,
            username: data.username || '',
            // 确保role为数字类型，兼容字符串'0'或'1'
            role: data.role !== undefined ? Number(data.role) : null,
            robot_id: data.robot_id || '',
            createTime: data.createTime || ''
          }
          
          // 设置用户信息
          commit('SET_USER_INFO', userInfo)
          
          // 保存登录接口返回的robot_id到cookie
          if (userInfo.robot_id) {
            setRobotId(userInfo.robot_id)
            console.log(`🔧 保存登录接口返回的robot_id到cookie: ${userInfo.robot_id}`)
          }
          
          // 设置角色和权限
          if (userInfo.role !== null) {
            commit('SET_ROLES', [userInfo.role])
          }
          commit('SET_PERMISSIONS', ['user:view', 'bill:view'])

          resolve(data)
        })
        .catch(error => {
          removeToken()
          removeRobotId()
          commit('RESET_USER')
          reject(error)
        })
    })
  },

  getUserInfo({ commit, state }) {
    return new Promise((resolve) => {
      const token = state.token
      if (!token) {
        resolve(null)
        return
      }
      const userInfo = { id: 1, username: 'admin', role: 0, robot_id: '' }
      commit('SET_USER_INFO', userInfo)
      commit('SET_ROLES', [userInfo.role])
      commit('SET_PERMISSIONS', ['user:view', 'user:edit', 'bill:view'])
      resolve(userInfo)
    })
  },

  logout({ commit }) {
    
    return new Promise((resolve) => {
      apiLogout(state.token)
        .then(() => {
          removeToken()
          removeRobotId()
          commit('RESET_USER')
          resetRouter()
          resolve()
        })
        .catch(error => {
          removeToken()
          removeRobotId()
          commit('RESET_USER')
          resetRouter()
           console.log('登出接口调用失败，但已清除本地状态:', error)
  
          resolve()
        })
    })
  },

  refreshToken({ commit }) {
    return new Promise((resolve) => {
      const newToken = 'new-token-from-refresh'
      commit('SET_TOKEN', newToken)
      setToken(newToken)
      resolve()
    })
  },


}

const getters = {
  token: state => state.token,
  userInfo: state => state.userInfo,
  permissions: state => state.permissions,
  roles: state => state.roles,
  userRole: state => state.userInfo.role,
  isSuperAdmin: state => state.userInfo.role === 0,
  isNormalUser: state => state.userInfo.role === 1,
  isLoggedIn: state => !!state.token && state.userInfo.role !== null
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
